export default __webpack_public_path__ + "static/media/i-chat.734a99c5.png";